import withNavigationTheme from '../../hooks/withNavigationTheme';
import AuthenticationStatus from './AuthenticationStatus';

export default withNavigationTheme(AuthenticationStatus);
